import styledCmp from 'styled-components'

import { styled } from '@mui/material/styles';
import Input from '@mui/material/Input'; // standard (material)
import { InputLabel } from '@mui/material';

// import Input from '@mui/material/FilledInput'; 
// import Input from '@mui/material/OutlinedInput'; 


export const MaterialInput = styled(Input)(({ theme, small, height, padding, transparent, noPadding, white, type, border, light }) => ({
    backgroundColor: transparent ? "transparent" : light ? theme.palette.colors.light : white ? theme.palette.colors.white : theme.palette.colors.inputSurface,
    height: small ? 42 : height ? height : 48,
    borderRadius: 14,
    padding: padding ? '8px' : noPadding ? '0px' : '0 8px',
    resize: 'none',
    border: border ? `1px solid ${theme.palette.colors.lightgrey}` : `1px solid ${theme.palette.colors.inputBorder}`,
    color: light ? theme.palette.colors.white : theme.palette.colors.text,
    boxShadow: `inset 0 1px 0 ${theme.palette.colors.borderSoft}`,
    transition: 'border-color 0.22s ease, box-shadow 0.22s ease, background-color 0.22s ease',
    '&:hover': {
        borderColor: theme.palette.colors.borderStrong,
    },
    '&.Mui-focused': {
        borderColor: theme.palette.blue.main,
        boxShadow: `0 0 0 4px ${theme.palette.colors.badgeMuted}`,
    },
    '&.Mui-disabled': {
        backgroundColor: transparent ? "transparent" : light ? theme.palette.colors.light : white ? theme.palette.colors.white : theme.palette.colors.inputSurface,
        borderColor: border ? theme.palette.colors.lightgrey : theme.palette.colors.inputBorder,
        color: light ? theme.palette.colors.white : theme.palette.colors.text,
        opacity: 1,
        WebkitTextFillColor: light ? theme.palette.colors.white : theme.palette.colors.text,
    },
    '& input, & textarea': {
        color: light ? theme.palette.colors.white : theme.palette.colors.text,
    },
    '& input.Mui-disabled, & textarea.Mui-disabled': {
        color: light ? theme.palette.colors.white : theme.palette.colors.text,
        opacity: 1,
        WebkitTextFillColor: light ? theme.palette.colors.white : theme.palette.colors.text,
    },
    '& input::placeholder, & textarea::placeholder': {
        color: theme.palette.colors.subdued,
        opacity: 1,
    },
    '& .MuiInputAdornment-root .MuiIconButton-root': {
        color: theme.palette.colors.subdued,
    },
    ...(type === 'textarea' ? {
        minHeight: 180,
        verticalAlign: "top",
        display: "block"
    } : {})
}));

export const InputIcon = styledCmp.img.attrs({
})`
`;

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    fontSize: "1rem",
    transform: "translate(0, -8px) scale(1)",
    transformOrigin: "top left",
    color: theme.palette.colors.subdued,
    fontWeight: 600,
    letterSpacing: '0.01em',
    '&.Mui-focused': {
        color: theme.palette.colors.white,
    },
}));
